import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ZoomOutIcon = (props: IconProps) => (
  <Icon w="24px" h="24px" viewBox="0 0 24 24" {...props}>
    <path d="M15.755 14.2549H14.965L14.685 13.9849C15.665 12.8449 16.255 11.3649 16.255 9.75488C16.255 6.16488 13.345 3.25488 9.755 3.25488C6.165 3.25488 3.255 6.16488 3.255 9.75488C3.255 13.3449 6.165 16.2549 9.755 16.2549C11.365 16.2549 12.845 15.6649 13.985 14.6849L14.255 14.9649V15.7549L19.255 20.7449L20.745 19.2549L15.755 14.2549ZM9.755 14.2549C7.265 14.2549 5.255 12.2449 5.255 9.75488C5.255 7.26488 7.265 5.25488 9.755 5.25488C12.245 5.25488 14.255 7.26488 14.255 9.75488C14.255 12.2449 12.245 14.2549 9.755 14.2549ZM7.255 9.25488H12.255V10.2549H7.255V9.25488Z" />
  </Icon>
);

export default memo(ZoomOutIcon);
